import { ApiErrorResult } from '@siza-staff-care/shared/data';

export abstract class BaseError {
	protected errorResult: ApiErrorResult;

	constructor(errorResult: ApiErrorResult) {
		this.errorResult = errorResult;
	}

	get message(): string {
		return this.errorResult.message;
	}

	get messages(): string[] {
		return this.errorResult.allMessages;
	}
}
